import { ToastColor, ToastLink, ToastOptions } from "./Toast"

export function errorToast(message?: string): ToastOptions {
  return {
    children: `Erreur: ${message}`,
    timeout: 1500,
    color: ToastColor.danger,
  }
}

export function successToast(message?: string): ToastOptions {
  return {
    children: message,
    timeout: 1500,
    color: ToastColor.success,
  }
}

export function infoToast(message?: string, link?: ToastLink): ToastOptions {
  return {
    children: message,
    timeout: 1500,
    color: ToastColor.info,
    link,
  }
}

export function warningToast(message?: string): ToastOptions {
  return {
    children: message,
    timeout: 1500,
    color: ToastColor.warning,
  }
}
